// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".options-list[data-v-fdf84a4a]{list-style:none;padding:0 0 10px}@media screen and (min-width:768px){.options-list[data-v-fdf84a4a]{padding:0 0 14px}}", ""]);
// Exports
module.exports = exports;
